module.exports = __webpack_public_path__ + "static/media/(H)-Prata-05.861ea743.jpg";